// Const
import { formLimitation } from 'const';

class Form {
  theme = null;

  constructor(theme) {
    this.theme = theme;
    Form.instance = this;
  }

  static init(theme) {
    Form.instance = null;
    return new Form(theme);
  }

  getFormStyle = () => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: 2,
    boxSizing: "border-box",
    gap: "20px",
  });

  getFormHeaderStyle = () => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    paddingLeft: '25px'
  });

  getFormBodyStyle = () => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: 2,
    boxSizing: "border-box",
    gap: "20px",
    overflow: "hidden"
  });

  getTextfieldStyle = (isValid) => ({
    width: "62.5%",
    "& .MuiOutlinedInput-root": {
      borderRadius: this.theme.shape.customBorderRadius[1],
      height: "31px",
      backgroundColor: this.theme.palette.primary.transparent,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.borderGreyPrimary
          : this.theme.palette.primary.redPrimary,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.mainHover
          : this.theme.palette.primary.redPrimary,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.main
          : this.theme.palette.primary.redPrimary,
      },
    },
  });

  checkPvid(value) {
    if (value === "") {
      return false;
    }

    if (!/^\d+$/.test(value)) {
      return false;
    }

    const intValue = Number(value);
    if (intValue < 1 || intValue > 4094) {
      return false;
    }

    return true;
  }

  checkAllowVlans(value) {
    if (!value?.trim()) return false;

    const parts = value.split(",").map(s => s.trim());
    const used = new Set();
    const { min, max } = formLimitation.vlanId;

    for (let part of parts) {
      if (part === "") return false;

      if (part.includes("-")) {
        const [startStr, endStr] = part.split("-").map(s => s.trim());
        const start = parseInt(startStr, 10);
        const end = parseInt(endStr, 10);

        if (
          isNaN(start) || isNaN(end) ||
          start < min || end > max ||
          start > end
        ) return false;

        for (let i = start; i <= end; i++) {
          if (used.has(i)) return false;
          used.add(i);
        }

      } else {
        const num = parseInt(part, 10);
        if (isNaN(num) || num < min || num > max) return false;

        if (used.has(num)) return false;
        used.add(num);
      }
    }

    return true;
  }

  checkDynamicSize(value) {
    let isValid = true;

    if(value === "" || value < 1 || value > 32) {
      isValid = false;
    }

    return isValid;
  }
}

export default Form;